import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Check, X, Loader2, Eye, PenLine } from "lucide-react";
import { API_BASE as API_URL } from "@/config/api";
import { catLabel } from "@/components/blog/BlogFeed";

export const AdminBlog = ({ token }) => {
  const navigate = useNavigate();
  const [status, setStatus] = useState("pending");
  const [items, setItems] = useState(null);
  const [busy, setBusy] = useState(null);
  const headers = { Authorization: `Bearer ${token}` };

  const load = async () => {
    setItems(null);
    try { setItems((await axios.get(`${API_URL}/blog/admin/posts?status=${status}`, { headers })).data); }
    catch { setItems([]); }
  };
  useEffect(() => { load(); }, [status]);

  const moderate = async (id, action) => {
    setBusy(id);
    try {
      await axios.post(`${API_URL}/blog/admin/posts/${id}/moderate?action=${action}`, {}, { headers });
      toast.success(action === "approve" ? "Опубликовано" : "Отклонено");
      await load();
    } catch (e) { toast.error(e.response?.data?.detail || "Ошибка"); } finally { setBusy(null); }
  };

  return (
    <div className="space-y-3" data-testid="admin-blog">
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <div className="flex gap-2">
          {[["pending", "На модерации"], ["published", "Опубликованные"], ["draft", "Черновики"], ["rejected", "Отклонённые"]].map(([s, l]) => (
            <Button key={s} size="sm" variant={status === s ? "default" : "outline"} onClick={() => setStatus(s)} data-testid={`admin-blog-tab-${s}`}>{l}</Button>
          ))}
        </div>
        <Button size="sm" onClick={() => navigate("/blog/new")} data-testid="admin-blog-new"><PenLine className="h-4 w-4 mr-1" />Новая публикация</Button>
      </div>
      {items === null ? <div className="flex justify-center py-10"><Loader2 className="h-6 w-6 animate-spin text-primary" /></div>
        : items.length === 0 ? <Card className="glass"><CardContent className="py-10 text-center text-muted-foreground">Пусто</CardContent></Card>
        : items.map((p) => (
          <Card key={p.id} className="glass" data-testid={`admin-post-${p.id}`}>
            <CardContent className="p-4 flex items-center justify-between gap-3 flex-wrap">
              <div className="min-w-0">
                <p className="font-semibold truncate">{p.title}</p>
                <p className="text-xs text-muted-foreground">{catLabel(p.category, "ru")} · {p.author_username} · {new Date(p.created_at).toLocaleString("ru-RU")} · 👁 {p.views} · ♥ {p.likes_count}</p>
              </div>
              <div className="flex gap-2">
                <Button size="sm" variant="ghost" onClick={() => navigate(`/blog/${p.slug}`)}><Eye className="h-4 w-4" /></Button>
                <Button size="sm" variant="ghost" onClick={() => navigate(`/blog/edit/${p.id}`)}><PenLine className="h-4 w-4" /></Button>
                {status !== "published" && <Button size="sm" disabled={busy === p.id} onClick={() => moderate(p.id, "approve")} data-testid={`admin-post-approve-${p.id}`}><Check className="h-4 w-4 mr-1" />Опубликовать</Button>}
                {status === "pending" && <Button size="sm" variant="destructive" disabled={busy === p.id} onClick={() => moderate(p.id, "reject")} data-testid={`admin-post-reject-${p.id}`}><X className="h-4 w-4" /></Button>}
              </div>
            </CardContent>
          </Card>
        ))}
    </div>
  );
};

export default AdminBlog;
